module.exports = __webpack_public_path__ + "img/f7bd380.jpg";